import * as yup from 'yup';

export const validationSchema1StepArup = yup.object().shape({
  profile: yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    usernameArup: yup.string().required('Username is required'),
    arupPassword: yup.string().required('Password is required'),
    regionName: yup.string().required('Region is required'),
    phone: yup.string().required('Phone is required'),
    address: yup.string().required('Address is required'), // address is required only for demand users
  }),
});

export const validationSchema1StepNonArup = yup.object().shape({
  profile: yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
    usernameArup: yup.string().required('Username is required'),
    arupPassword: yup.string().required('Password is required'),
    phone: yup.string().required('Phone is required'),
  }),
});
